import PropTypes from 'prop-types'
import React from 'react'

function A11yTextLink({ href, text }) {
  return (
    <a className="a11y-text-link" href={href} target="_blank">
      {text} <span aria-hidden="true">→</span>
    </a>
  )
}

A11yTextLink.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
}

export default A11yTextLink
